import { useAtom } from "jotai";
import { uiContextState } from "@/custolink-state/ui_context_state";
import {
  AdmUserApi$CurrentAuthedUser,
  AssetFrontendUserApi$CurrentAuthedUser,
  WebAppMainApi$ControlpanelContext,
  WebAppMainApi$OrganisationContext,
  WebAppMainApi$UiContext,
} from "@/custolink-transpiled_by_server/bc.identity_and_access.api_methods";
import { uiAdminAreaAuthState } from "@/custolink-state/ui_admin_area_auth_state";
import { uiAssetFrontendAuthState } from "@/custolink-state/ui_asset_frontend_auth_state";
import { useMemo } from "react";
import { uiAssetFrontendLanguageState } from "@/custolink-state/ui_asset_frontend_language";

type UseUiContextReturn = {
  organisationContext: WebAppMainApi$OrganisationContext;
  controlpanelContext: WebAppMainApi$ControlpanelContext;

  adminAreaAuthedUser: AdmUserApi$CurrentAuthedUser;
  isAuthedAsAdminAreaUser: boolean;

  assetFrontendAuthedUser: AssetFrontendUserApi$CurrentAuthedUser | null;
  assetFrontendlanguageCode: string;
  setAssetFrontendlanguageCode: (langCode: string) => void;

  _orgId: number;
};

export default function useUiContext(): UseUiContextReturn {
  const [uiContext] = useAtom(uiContextState);
  const [adminAreaAuthState] = useAtom(uiAdminAreaAuthState);
  const [assetFrontendAuthState] = useAtom(uiAssetFrontendAuthState);
  const [assetFrontendLanguageCode,setAssetFrontendlanguageCode] = useAtom(
    uiAssetFrontendLanguageState,
  );

  const _orgId = useMemo(() => {
    if (uiContext != false) {
      const uc = uiContext as WebAppMainApi$UiContext;
      if (uc.organisationContext != null) {
        return (uc.organisationContext as WebAppMainApi$OrganisationContext)
          .organisationId;
      }
    }
    return -1;
  }, [
    (uiContext as WebAppMainApi$UiContext)?.organisationContext?.organisationId,
  ]);

  return {
    // can be used accessed if indeed rendering in the context of an Organisation
    organisationContext: (uiContext as WebAppMainApi$UiContext)
      .organisationContext as WebAppMainApi$OrganisationContext,

    controlpanelContext: (uiContext as WebAppMainApi$UiContext)
      .controlpanelContext as WebAppMainApi$ControlpanelContext,

    isAuthedAsAdminAreaUser: adminAreaAuthState != false,

    // assuming not false when called (since is called in a context where the admin area user is absolutely signed in)
    adminAreaAuthedUser: (adminAreaAuthState ??
      null) as AdmUserApi$CurrentAuthedUser,

    // in asset frontend, a user may browse around without being signed in
    assetFrontendAuthedUser:
      assetFrontendAuthState != false ? assetFrontendAuthState : null,

    assetFrontendlanguageCode: assetFrontendLanguageCode,
    setAssetFrontendlanguageCode : setAssetFrontendlanguageCode,

    _orgId: _orgId,
  };
}
